import type { PeriodPreset } from "./period-presets";

export type ExplorerFormat = "appointment" | "item";

export type ItemCountOperator = "gte" | "eq" | "lte";
export type ItemCountScope = "all" | "products" | "services";
export type ItemTypeValue = "PRODUTO" | "SERVICO" | "PACOTE";
export type FinancialStatusFilter = "all" | "paid" | "open";

export interface ItemCountFilter {
  operator: ItemCountOperator;
  scope: ItemCountScope;
  value: number;
}

export interface SalesExplorerFilters {
  /** Preset que originou `from`/`to`. Só a UI usa; a RPC consome from/to. */
  period: PeriodPreset;
  from: string;
  to: string;
  appointmentTypeIds: string[];
  appointmentStatuses: string[];
  professionalIds: string[];
  financialStatus: FinancialStatusFilter;
  itemIds: string[];
  itemTypes: ItemTypeValue[];
  categoryIds: string[];
  itemCount: ItemCountFilter | null;
  speciesIds: string[];
  breedIds: string[];
  sizeCategoryIds: string[];
  weightMin: number | null;
  weightMax: number | null;
  ownerSearch: string;
  ownerCity: string;
  ownerNeighborhood: string;
  page: number;
  pageSize: number;
}

export interface ExplorerSaleItem {
  saleItemId: string;
  itemId: string | null;
  itemName: string;
  itemType: ItemTypeValue | null;
  quantity: number;
  unitPrice: number;
  lineTotal: number;
  matched: boolean;
}

export interface AppointmentRow {
  id: string;
  occurredAt: string;
  petId: string | null;
  petName: string | null;
  ownerId: string | null;
  ownerName: string | null;
  appointmentType: string | null;
  appointmentTypeColor: string | null;
  appointmentStatus: string | null;
  professionalId: string | null;
  financialStatus: "pago" | "em_aberto";
  itemCount: number;
  value: number;
  items: ExplorerSaleItem[];
}

export interface ItemRow {
  id: string;
  occurredAt: string;
  itemName: string;
  itemType: ItemTypeValue | null;
  petId: string | null;
  petName: string | null;
  ownerId: string | null;
  ownerName: string | null;
  professionalId: string | null;
  quantity: number;
  unitPrice: number;
  lineTotal: number;
}

export type SalesExplorerResult =
  | {
      format: "appointment";
      rows: AppointmentRow[];
      totalCount: number;
      totalQuantity: number;
      totalValue: number;
      averageValue: number;
    }
  | {
      format: "item";
      rows: ItemRow[];
      totalCount: number;
      totalQuantity: number;
      totalValue: number;
      averageValue: number;
    };

export const DEFAULT_PAGE_SIZE = 50;

export const EMPTY_FILTERS: SalesExplorerFilters = {
  period: "month",
  from: "",
  to: "",
  appointmentTypeIds: [],
  appointmentStatuses: [],
  professionalIds: [],
  financialStatus: "all",
  itemIds: [],
  itemTypes: [],
  categoryIds: [],
  itemCount: null,
  speciesIds: [],
  breedIds: [],
  sizeCategoryIds: [],
  weightMin: null,
  weightMax: null,
  ownerSearch: "",
  ownerCity: "",
  ownerNeighborhood: "",
  page: 1,
  pageSize: DEFAULT_PAGE_SIZE,
};
